/**
 * upload-file.js
 */
export const UploadFile = (function () {

  var image;

  var init =  function () {   
          
    $(".custom-file-input").on("change", function() {
      var fileName = $(this).val().split("\\").pop();
      $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });

    $('#myds-upload-file').on('click', processUpload);
       
  }

  var processUpload = function(e) {
      e.preventDefault();

      if(imageExists()) {
        var imageSize = image[0].size / 1024 / 1024;

        if(imageSize > 1) {
          Util.toggleAlert('#myds-alert-upload-file', 'Image size is too large, please select an image smaller than 1MB', 'alert-warning');
          return;
        }

        return uploadFile(image);
      }
  }

  var imageExists = function() {
    image = $('#myds-choose-file')[0].files;

    return image.length != 0
  }

  var uploadFile = function (file) {
    var url = $('#myds-upload-file-form').attr('action');
    var name = file[0].name;
    var csrf = Util.getCSRF();
    var formData = new FormData();
    formData.append('myds-uploaded-file', file[0]);

    return $.ajax({
      type: 'POST',
      url: url,
      headers: {
        'isAPI': true,
        'x-csrf-token': csrf
      },
      cache: false,
      contentType: false,
      processData: false,
      data: formData
    }).done(function (response) {
      if ($('.myds-uploaded-file-name').length != 0) {
        $('.myds-uploaded-file-name').text(name);
      } else {
        var html = '<p class="text-primary mt-2">Currently uploaded logo: <b class="myds-uploaded-file-name">' + name + '</b></p>'
        $('#myds-alert-upload-file').after(html);
      }
      $('.custom-file-label').text('Choose PNG, JPEG, SVG');
      Util.toggleAlert('#myds-alert-upload-file', 'Image uploaded succesfully', 'alert-primary');
    }).fail(function (err) {
      var error = err.responseJSON.message;
      Util.toggleAlert('#myds-alert-upload-file', error, 'alert-warning', 5000);
    });
  };

  return {
    init: init,
    processUpload: processUpload,
    imageExists: imageExists
  }

}());


